import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import '../fonts/fonts.css';

const useStyles = makeStyles({
	minWidth: {
		width: '100%',
	},
	titleH6: {
		lineHeight: 1.2,
	},
	marginCard: {
		margin: '0 0 8px 0',
	}
});

const CardBody = ({title, cardClass}) => {

	const classes = useStyles();

    return (
		<Card className={classes.minWidth, classes.marginCard}>
			<Box display="flex" justifyContent="center" p={1}>
				<div className={cardClass}></div>
			</Box>
			<Box p={1}>
				<Typography className={classes.titleH6} align="center" variant="h6" component="h2">
					{title}
				</Typography>
			</Box>
		</Card>
    )
}

export default CardBody;